/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import { PutAwayLinesService } from '@control-tower/platform-wms';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    PFWmsEntities,
} from '@pf/shared-common';
import { PutAwayStore } from './put-away.store';
import {
    PutAwayCreate,
    PutAwayRead,
    PutAwaySearchParams,
} from '../../entities/put-away.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class PutAwayDataService extends AbstractDataService<
    PutAwayRead,
    PutAwayCreate
> {
    protected EntityName = PFWmsEntities.PutAway;

    constructor(
        private service: PutAwayLinesService,
        store: PutAwayStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }

    protected createObs$(
        body: PutAwayCreate,
        parentId?: string
    ): Observable<PutAwayRead> {
        return this.service.putAwayCreate({
            putAwayListId: parentId as string,
            putAwayViewModelCreateBody: body,
        }) as Observable<PutAwayRead>;
    }

    protected deleteObs$(
        id: string,
        parentId?: string
    ): Observable<PutAwayRead> {
        return this.service.putAwayDelete({
            id,
            putAwayListId: parentId as string,
        }) as Observable<PutAwayRead>;
    }

    protected undoDeleteObs$(
        id: string,
        parentId?: string
    ): Observable<PutAwayRead> {
        return this.service.putAwayUndoDelete({
            id,
            putAwayListId: parentId as string,
        }) as Observable<PutAwayRead>;
    }

    protected getObs$(id: string, parentId?: string): Observable<PutAwayRead> {
        return this.service.putAwayReadById({
            id,
            putAwayListId: parentId as string,
        }) as Observable<PutAwayRead>;
    }

    protected updateObs$(
        id: string,
        operations: Operation[],
        _: PutAwayCreate,
        parentId?: string
    ): Observable<PutAwayRead> {
        return this.service.putAwayUpdatePatch({
            id,
            putAwayListId: parentId as string,
            operation: operations,
        }) as Observable<PutAwayRead>;
    }

    protected searchObs$(
        searchParams: PutAwaySearchParams
    ): Observable<IPagedResult<PutAwayRead>> {
        return this.service.putAwaySearch(searchParams) as Observable<
            IPagedResult<PutAwayRead>
        >;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<IPagedResult<EntityChangeTrackingDto<PutAwayRead>>> {
        const { parentId, ...params } = searchParams;
        return this.service.putAwayGetChanges({
            ...params,
            putAwayListId: parentId as string,
        }) as Observable<IPagedResult<EntityChangeTrackingDto<PutAwayRead>>>;
    }
}
